document.addEventListener('DOMContentLoaded', async () => {


  // Function to get variant from the URL
  const getVariantFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant'); // This should return a string or null if not found
  };

  // Get the productId from window object
  const productId = window.productId;
  let variantId = getVariantFromURL(); // Get variant from URL

  // If variantId is an object or not found, handle it
  if (typeof variantId !== 'string' || variantId === null) {

    variantId = window.variantId && typeof window.variantId === 'string' ? window.variantId : null;
  }

  // Elements to interact with
  const availabilityButton = document.querySelector('.open-availability-drawer');
  const drawer = document.querySelector('.js-availability-drawer');
  const drawerContent = document.querySelector('.availability-content');
  const addToCartButton = document.querySelector('.add-to-cart');
  let productData = null;

  // Fetch product data and handle variant fallback
  const fetchProductData = async () => {
  
    try {
      const response = await fetch(`https://sell.takeoffcph.dk/api/shopify/inventorylevels?q=${productId}`);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      productData = data.body.data.product;
     

      // If no valid variantId from URL or window, fallback to the first variant in API response
      if (!variantId && productData.variants.edges.length > 0) {
        variantId = productData.variants.edges[0].node.id.split('/').pop(); // Extract ID from gid
        console.log(`No variant ID found, using first available variant ID: ${variantId}`);
      }

      // Update the UI for the resolved variantId
      updateUIForVariant(variantId);

    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  };

  // Update UI for a given variant ID
const updateUIForVariant = (variantId) => {
  if (!productData || !productData.variants) {
    return;
  }

  // Ensure variantId is a string
  if (typeof variantId !== 'string') {
    console.error('Invalid variantId, expected a string, received:', variantId);
    return;
  }

  // Find the variant using the correct ID format
  const variant = productData.variants.edges.find(v => v.node.id.endsWith(variantId))?.node;
  if (!variant) {
    console.error(`Variant with ID ${variantId} not found`);
    return;
  }

  const availableForSale = variant.availableForSale;
  const storeAvailability = variant.storeAvailability.edges;
  const tags = productData.tags || [];
  
  // Build store availability UI
  let inStockStores = 0;
  let availabilityHTML = '';
  storeAvailability.forEach(edge => {
    const { location, available, quantityAvailable } = edge.node;
    const isInStock = available && quantityAvailable > 0;
    const cleanedLocationName = location.name.replace(/\(Pick-up\)/g, '').trim();
    inStockStores += isInStock ? 1 : 0;
  
    availabilityHTML += `
      <div class="store">
        <div class="title-store-availability">
          <h4>${cleanedLocationName}</h4>
          <div class="availability-indicator ${isInStock ? 'in-stock' : 'out-of-stock'}">
            ${isInStock ? 'Available' : 'Unavailable'}
          </div>
        </div>
        <p>${location.address.formatted.join(', ')}</p>
        <p>${location.address.phone}</p>
      </div>
    `;
  });
  
  const onlineStoreAvailability = availableForSale ? 'Available' : 'Unavailable';
  const onlineStoreIndicatorClass = availableForSale ? 'in-stock' : 'out-of-stock';
  const onlineStoreHTML = `
    <div class="store">
      <div class="title-store-availability">
        <h4>Online store</h4>
        <div class="availability-indicator ${onlineStoreIndicatorClass}">
          ${onlineStoreAvailability}
        </div>
      </div>
    </div>
  `;
  
  availabilityHTML = onlineStoreHTML + availabilityHTML;
  if (drawerContent) {
    drawerContent.innerHTML = availabilityHTML;
  }
  
  // Determine delivery text based on store availability and tags
  let deliveryText = '';
  if (inStockStores > 0) {
    deliveryText = ' (48 hours delivery)';
  } else if (tags.includes('delivery:rare')) {
    deliveryText = ' (5-10 delivery days)';
  } else if (tags.includes('delivery:vrare')) {
    deliveryText = ' (10-20 delivery days)';
  } else if (tags.includes('delivery:limited')) {
    deliveryText = ' (2-8 delivery days)';
  }

  // Update the Add-to-Cart button state
  if (addToCartButton) {
    if (!availableForSale) {
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Sold out';
      addToCartButton.classList.add('sold-out');
    } else {
      addToCartButton.disabled = false;
      const addToCartText = 'Add to cart';
      addToCartButton.textContent = `${addToCartText}${deliveryText}`;
      addToCartButton.dataset.addToCartText = `${addToCartText}${deliveryText}`;
      addToCartButton.classList.remove('sold-out');
    }
  }
  
  // Update the Availability button state
  if (availabilityButton) {
    if (!availableForSale) {
      availabilityButton.disabled = true;
      availabilityButton.textContent = 'Sold out';
      availabilityButton.classList.add('sold-out');
    } else {
      availabilityButton.disabled = false;
      if (inStockStores === 1) {
        availabilityButton.innerHTML = `Available in-stock in <span class="underline">${inStockStores}</span> store →`;
      } else if (inStockStores > 1) {
        availabilityButton.innerHTML = `Available in-stock in <span class="underline">${inStockStores}</span> stores →`;
      } else {
        availabilityButton.innerHTML = 'Available online';
      }
      availabilityButton.classList.remove('sold-out');
    }
  }
};


  // Load product data and initialize UI
  await fetchProductData();

  // Update the UI when the variant is changed by the user
  document.addEventListener('change', (event) => {
    if (event.target.matches('[name="id"]')) {
      const newVariantId = event.target.value;
      if (newVariantId && newVariantId !== variantId) {
        variantId = newVariantId;
    
        updateUIForVariant(newVariantId);
      }
    }
  });

  // Handle drawer open/close
  if (availabilityButton) {
    availabilityButton.addEventListener('click', () => {
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('is-open');
      }
    });
  }

  document.querySelectorAll('.js-close-drawer').forEach(btn => {
    btn.addEventListener('click', () => {
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
        drawer.classList.remove('is-open');
      }
    });
  });
});

